
'use client';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp, Target, SearchCheck, Lightbulb, BarChartBig, Settings2, Accessibility } from 'lucide-react';

const services = [
  {
    icon: <BarChartBig className="h-10 w-10 text-primary mb-4" />,
    title: 'Deep Performance Analysis',
    description: 'We scrutinize Core Web Vitals (FCP, LCP, CLS), TTI, Speed Index, and more to pinpoint performance bottlenecks.',
  },
  {
    icon: <Target className="h-10 w-10 text-primary mb-4" />,
    title: 'Analytics & Tracking Audit',
    description: 'Ensure your Google Analytics, Tag Manager, and custom tracking events are correctly implemented for accurate data collection.',
  },
  {
    icon: <SearchCheck className="h-10 w-10 text-primary mb-4" />,
    title: 'SEO Health Check',
    description: 'Our audit covers essential on-page SEO factors, helping you identify areas for improved search engine visibility.',
  },
  {
    icon: <Settings2 className="h-10 w-10 text-primary mb-4" />,
    title: 'Technical Web Audit',
    description: 'We identify technical issues like broken links, crawl errors, mobile-friendliness, and site structure problems.',
  },
  {
    icon: <Accessibility className="h-10 w-10 text-primary mb-4" />,
    title: 'Accessibility Audit',
    description: 'Ensure your website is inclusive and usable by people of all abilities, meeting WCAG standards.',
  },
  {
    icon: <Lightbulb className="h-10 w-10 text-primary mb-4" />,
    title: 'Actionable AI Recommendations',
    description: 'Receive a prioritized list of clear, actionable optimization suggestions powered by advanced AI insights.',
  },
   {
    icon: <TrendingUp className="h-10 w-10 text-primary mb-4" />,
    title: 'Conversion Rate Optimization (CRO) Insights',
    description: 'Uncover opportunities to improve user experience and increase conversion rates based on audit findings.',
  },
];

export function ServicesOverviewSection() {
  return (
    <section className="py-12 sm:py-16 w-full">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl font-headline">
            What Our AI Audit Covers
          </h2>
          <p className="mt-4 text-lg leading-8 text-muted-foreground">
            A comprehensive look into the critical aspects of your website&apos;s health and performance.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <Card key={service.title} className="shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col">
              <CardHeader className="items-center text-center">
                {service.icon}
                <CardTitle className="text-xl font-headline">{service.title}</CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <p className="text-muted-foreground text-center">{service.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
